import { Component, effect, inject, OnDestroy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PlanType } from '@bn/app-shield/enums';
import { CDN_ROUTES } from '@bn/dashboard-core/constants';
import { AbstractLazyDirective } from '@bn/shared/entities/abstracts/abstract-lazy.directive';
import { RouteUtils } from '@bn/shared/utils';
import { ShieldApiStore } from '../../stores';

@Component({
  templateUrl: './manage-app-shield.page.html',
  styleUrls: ['./manage-app-shield.page.scss'],
  imports: [RouterModule],
})
export class ManageAppShieldPage extends AbstractLazyDirective implements OnDestroy {
  readonly #shieldApiStore = inject(ShieldApiStore);
  readonly #selectedShield = this.#shieldApiStore.selectedEntity();

  constructor() {
    super();

    this.#shieldApiStore.getShieldDefaults();

    effect(() => {
      const plan = this.#selectedShield()?.planType ?? 0;

      if (plan > PlanType.Basic) {
        const planName = PlanType[plan];

        this.contentService.setBadge({
          contextType: 'premium',
          text: planName,
          tooltip: `You have Bunny Shield ${planName} enabled`,
        });
      } else {
        this.contentService.setBadge(null);
      }
    });

    effect(() => {
      const isSetupRequired = this.#shieldApiStore.setupRequired();
      if (isSetupRequired === undefined || isSetupRequired === null) return;

      // If setup is required and route is not setup redirect user to setup
      if (isSetupRequired && !RouteUtils.isDataPropertyActiveInChildPages(this.route, 'isShieldSetupPage')) {
        this.router.navigate([CDN_ROUTES.ShieldSetup], {
          queryParams: { step: 1 },
          relativeTo: this.route,
        });

        return;
      }

      // If setup is not required and user lands on setup redirect to overview
      if (!isSetupRequired && RouteUtils.isDataPropertyActiveInChildPages(this.route, 'isShieldSetupPage')) {
        this.router.navigate([CDN_ROUTES.ShieldOverview], { relativeTo: this.route });
      }
    });
  }

  public override ngOnDestroy(): void {
    this.contentService.setBadge(null);
    super.ngOnDestroy();
  }
}
